// https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
const getScrollBarWidth = () => {
  const el = document.createElement('div')
  el.style.cssText = 'overflow:scroll; visibility:hidden; position:absolute;'
  document.body.appendChild(el)
  const width = el.offsetWidth - el.clientWidth
  el.remove()
  return width
}

export const lockBodyScroll = () => {
  if (typeof window !== 'undefined') {
    const scrollY = document.documentElement.style.getPropertyValue('--scroll-y')
    document.body.style.position = 'fixed'
    document.body.style.overflow = 'hidden'
    document.body.style.top = `-${scrollY}`

    const scrollBarCompensation = getScrollBarWidth()
    document.body.style.paddingRight = `${scrollBarCompensation}px`
    if (document.getElementsByTagName('header')[0])
      document.getElementsByTagName('header')[0].style.paddingRight = `${scrollBarCompensation}px`
    // document.body.style['overscroll-behavior'] = 'none' // Will SUPPORT on Safari 16
  }
}

export const unlockBodyScroll = () => {
  if (typeof window !== 'undefined' && isBodyLocked()) {
    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.overflow = ''
    document.body.style.top = ''
    document.body.style.paddingRight = ''
    if (document.getElementsByTagName('header')[0]) document.getElementsByTagName('header')[0].style.paddingRight = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
    // document.body.style['overscroll-behavior'] = '' // Will SUPPORT on Safari 16
  }
}

export const onScroll = () => {
  if (typeof window !== 'undefined' && !window.location.hash) {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`)
  }
}

export const scrollTo = (element, timeout = 500) => {
  setTimeout(() => {
    if (document.getElementById(element)) {
      document.getElementById(element).scrollIntoView({
        behavior: 'smooth',
      })
    }
  }, timeout)
}

export const isBodyLocked = () => document.body.style.position === 'fixed'
